module.exports = __webpack_public_path__ + "img/connectia-primary.8cbe9166.svg";